// LEGACY
export { default as Text } from './generic-text-input';
export { default as Textarea } from './generic-textarea-input';
export { default as Select } from './generic-select-input';
export { default as Phone } from './generic-phone-input';
export { default as PhoneV2 } from './generic-phone-input-v2';
export { default as CheckBox } from './generic-checkbox-input';
export { default as Country } from './generic-country-input';
export { default as Part } from './generic-part-input';
export { default as CountryShipping } from './generic-country-shipping-input';
